import { List } from 'immutable'
import { getEntity, getEntityMap } from 'data'
import { createSelector } from 'reselect'
import { getActiveOrganizationId } from '../ui/selectors'

const getOrganizationUserGroupConnection = createSelector(
  getActiveOrganizationId,
  state => getEntityMap(state, 'UserGroupConnection'),
  function getOrganizationUserGroupConnection(
    organizationId,
    userGroupConnections
  ) {
    return userGroupConnections.get(organizationId)
  }
)

export function getAllUserGroups(state) {
  return getEntityMap(state, 'UserGroup')
}

export const listOrganizationUserGroups = createSelector(
  getOrganizationUserGroupConnection,
  getAllUserGroups,
  (organizationUserGroupConnection, allUserGroups) => {
    if (!organizationUserGroupConnection) {
      return List()
    }
    return organizationUserGroupConnection
      .get('nodes')
      .toList()
      .map(node => {
        return allUserGroups.find(userGroup => userGroup.id === node.id)
      })
  }
)

export function getUserGroup(state, userGroupId) {
  return getEntity(state, 'UserGroup', userGroupId)
}

function getUserGroupMembersConnection(state, userGroupId) {
  return getEntity(state, 'UserConnection', userGroupId)
}

export const getUserGroupMembers = createSelector(
  getUserGroupMembersConnection,
  state => getEntityMap(state, 'User'),
  (userConnection, allUsers) => {
    if (!userConnection) {
      return []
    }
    return userConnection.nodes.map(({ id }) => allUsers.get(id))
  }
)
